import { useEffect, useState } from "react";
import TrackingAPI from "api/TrackingAPI";
import audio_default_icon from 'assets/audio_default_icon.svg';
import audio_mute_icon from 'assets/audio_mute_icon.svg';
import { analyticsService } from 'services/analyticsService';
import styled from 'styled-components';

import { useSoundEnabled } from '../../hooks/useSoundEnabled';

interface IAnalyticData {
  scenario?: {
    name?: string;
  };
  game?: {
    name?: string;
  };
  dialogId?: string | number;
}

interface AudioButtonProps {
  src: string;
  label?: string;
  analyticData?: IAnalyticData;
}

const AudioButton: React.FC<AudioButtonProps> = (props) => {
  const { src = '/', label, analyticData } = props;
  const [audio] = useState(() => new Audio(src));
  const { isSoundEnabled, toggleSound } = useSoundEnabled();

  const playAudio = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isSoundEnabled) {
      audio.currentTime = 0;
      audio.play();
    }
    if (analyticData) {
      TrackingAPI.trackEvent('click_voice_button', {
        config_name: analyticData.scenario?.name || '',
        scenario_name: analyticData.game?.name || '',
        dialogId: analyticData.dialogId
      });
      analyticsService.trackGoogleEvent('click_voice_button', {
        config_name: analyticData.scenario?.name || '',
        scenario_name: analyticData.game?.name || '',
        dialogId: analyticData.dialogId
      });
    }
    toggleSound();
  };

  useEffect(() => {
    audio.muted = !isSoundEnabled;
  }, [isSoundEnabled, audio]);

  return (
    <button onClick={playAudio}>
      {!label && <VoiceIcon src={isSoundEnabled ? audio_default_icon : audio_mute_icon} />}
      {label && (
        <VoiceIconWithLabelWrapper>
          <VoiceIcon src={isSoundEnabled ? audio_default_icon : audio_mute_icon} />
          {label}
        </VoiceIconWithLabelWrapper>
      )}
    </button>
  );
};

export default AudioButton;

const VoiceIcon = styled.img`
  width: 24px;
  height: fit-content;
  cursor: pointer;
`;

const VoiceIconWithLabelWrapper = styled.div`
  width: auto;
  height: 28px;
  display: flex;
  border-radius: 20px;
  padding-right: 12px;
  font-family: Nunito Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  background: white;
  color: #100d0b;
  align-items: center;
  padding-left: 2px;
  gap: 4px;
  font-family: Nunito Sans;
`;